import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Resources from "@/pages/Resources";

export const Route = createFileRoute("/knowledge-center")({
  head: () => buildRouteHead("/knowledge-center"),
  component: Resources,
});

